import * as React from 'react';

import { Button, Modal } from '@watcherr/ui';
import { t } from '~/i18n';
import Alert from '~store/Alert/Alert';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

interface AlertCancelledContainerProps {
  alert: Alert;
}

const AlertCancelledContainer: React.FC<AlertCancelledContainerProps> = ({ alert }) => {
  const navigate = useNavigate();
  const wasAccepted = React.useRef(alert.isAcceptedOwnExcluded);
  const [showModal, setShowModal] = React.useState(false);
  React.useEffect(() => {
    if (!wasAccepted.current && alert.isAcceptedOwnExcluded) {
      setShowModal(true);
    }
    wasAccepted.current = alert.isAcceptedOwnExcluded;
  }, [alert.isAcceptedOwnExcluded]);

  if (!showModal) {
    return null;
  }
  return (
    <Modal center>
      <h3 className="text-center mb-30">{t('alert.aprovedByOther.title')}</h3>
      <p>{t('alert.aprovedByOther.description')}</p>
      <Button onClick={() => navigate('/alerts')}>{t('alert.aprovedByOther.goBack')}</Button>
    </Modal>
  );
};

export default observer(AlertCancelledContainer);
